// extracted by mini-css-extract-plugin
export default {"cardContainer":"as_tL","icon":"ByCAJ","responsive":"NkQCK","bigCard":"Ge0uE","img":"pUGtV"};